
















import { Component } from "vue-property-decorator";
import { BaseControl } from "../controls/base/base-control";
import { DropDownItem } from "../drop-down/types";
import { timezonesList } from "@common/data/timezones";
import TzDropdown from "./tz-dropdown.vue";

@Component({ components: { TzDropdown } })

export default class TZSelector extends BaseControl {

    showDropdown = false;
    title = "";
    list: DropDownItem[] = [];

    mounted() {
        this.list = timezonesList;
        this.title = this.list.find((item) => item.id === this.value)?.title.split('(')[0]?.trim() || "";
    }

    select(item: DropDownItem) {
        this.showDropdown = false;
        this.title = item.title.split('(')[0]?.trim();
        this.$emit('input', item.id);
    }
}

